<template>
    <div class="card my-3 border-1">
        <div v-if="loading">
            <Skeleton class="mb-2" height="10rem" borderRadius="16px" />
            <ScaleLoader class="custom-loader" />
        </div>
        <ul v-else class="list-none p-0 m-0">
            <li v-for="attribute in userProfileAttributes" class="border-bottom-1 surface-border flex" :key="attribute.id">
                <div class="text-500 font-medium col-3">{{ attribute.label }}</div>
                <div class="text-900 col-9">
                    {{ getAnswerValue(attribute) }}
                </div>
            </li>
        </ul>
    </div>
</template>

<script setup>
import { ref, onMounted, defineProps } from 'vue';
import { storeToRefs } from 'pinia';
import { useAnswerStore } from '../store';
import { useAssessmentFormStore } from '../../assessment-form/store';
import { formatDisplayDate } from '@/helpers/date-formatter';

const answerStore = useAnswerStore();
const formStore = useAssessmentFormStore();

const { userProfileAnswer, loading } = storeToRefs(answerStore);
const { currentStep } = storeToRefs(formStore);

// to store the latest user profile attributes
const userProfileAttributes = ref([]);

const props = defineProps({
    userId: {
        type: [String, Number],
        required: true,
    },
});

onMounted(async () => {
    await answerStore.getLatestUserProfileAnswer(props.userId);
    await fetchUserProfileAttributes();
});

// fetch respective answers depending upon attribute type, code and so on
const getAnswerValue = (attribute) => {
    const answer = userProfileAnswer.value?.find((answer) => answer.code === attribute?.code)?.answer;
    // check if attribute is option type, if yes then extract the option value
    // DROP_DOWN: 8, MULTI_DROP_DOWN: 9, RADIO: 10, CHECKBOX: 11,
    if ([8, 9, 10, 11].includes(parseInt(attribute.type))) {
        const selectedOption = attribute.options.find((option) => option.value === parseInt(answer));
        // check if the selected option is valid or not
        if (selectedOption) {
            // if yes, extract the label and return it
            return selectedOption?.label;
        } else {
            return 'N/A';
        }
    }
    // Else if check if its date type DATE:7
    else if (parseInt(attribute.type) === 7) {
        // debugger;
        return formatDisplayDate(answer);
    }
    // Else just return the answer value
    else {
        return answer ?? 'N/A';
    }
};

const fetchUserProfileAttributes = async () => {
    // get the latest user profile form
    await formStore.initiateAnswerForm('user_profile');
    // currentStep is loaded in the assessmentForm store and then use it to extract the label and code for displaying
    userProfileAttributes.value = currentStep.value?.block?.form_attributes
        ?.filter((attribute) => ![1, 2, 3].includes(parseInt(attribute.type)))
        ?.map((item) => {
            return {
                label: item.label,
                code: item.code,
                options: item.options,
                type: item.type, // type is required for figuring out attribute type
            };
        });
};
</script>

<style scoped>
.custom-loader {
    top: 35vh;
    right: 40vw;
}
</style>
